import React from 'react';
import HealthTracker from './HealthTracker';

function App() {
  return <HealthTracker />;
}

export default App;
